import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const WEEKDAYS = ['日', '一', '二', '三', '四', '五', '六'];

const getGreeting = (hour) => {
  if (hour < 6) return '凌晨好';
  if (hour < 9) return '早上好';
  if (hour < 12) return '上午好';
  if (hour < 14) return '中午好';
  if (hour < 18) return '下午好';
  if (hour < 20) return '傍晚好';
  return '晚上好';
};

const WelcomeHeader = ({ name }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const refresh = () => setNow(new Date());
    const onVisibilityChange = () => {
      if (!document.hidden) refresh();
    };
    const timer = window.setInterval(refresh, 60000);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  const greeting = getGreeting(now.getHours());
  const date = `${now.getMonth() + 1}月${now.getDate()}日 · 星期${WEEKDAYS[now.getDay()]}`;
  const dateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

  return (
    <header className="top-box">
      <div className="welcome-copy">
        <p className="welcome-title" title={`${greeting}${name ? `，${name}` : ''}`}>
          <span className="welcome-greeting">{greeting}{name ? '，' : ''}</span>
          {name && <span className="welcome-name">{name}</span>}
        </p>
        <p className="welcome-date"><time dateTime={dateTime}>{date}</time></p>
      </div>
    </header>
  );
};

WelcomeHeader.propTypes = { name: PropTypes.string };
WelcomeHeader.defaultProps = { name: '' };

export default WelcomeHeader;
